import { Component, Input } from '@angular/core';
import { SharedModule } from '@Shared/shared.module';


@Component({
    selector: 'img-viewer',
    templateUrl: './img-viewer.component.html',
    styleUrls: ['./img-viewer.component.scss'],
    imports: [SharedModule]
})
export default class ImgViewer {
    @Input() src: string;
}
